import { AddIcon } from '@chakra-ui/icons'
import { IconButton, Tooltip } from '@chakra-ui/react'
import { useThreadsList } from '@hb/react'

export const CreateThreadButton = ({ bg }: { bg: string }) => {
  const {
    widget: { setCreatingNewThread },
  } = useThreadsList()
  return (
    <Tooltip
      color="white"
      textShadow="1px 1px 3px #000000cc"
      placement="top"
      hasArrow
      bg={bg}
      label="Create New Thread">
      <IconButton
        size="xs"
        onClick={() => setCreatingNewThread(true)}
        bg="blackAlpha.300"
        _hover={{ bg: 'blackAlpha.500' }}
        color="white"
        aria-label="Create Thread"
        icon={<AddIcon />}
      />
    </Tooltip>
  )
}
